import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
const CircularProgressWithLabel = props => {
	return (
		<Box sx={{ position: 'relative', display: 'inline-flex' }}>
			{props.value ? (
				<CircularProgress variant='determinate' size={100} {...props} />
			) : (
				<CircularProgress size={100} {...props} />
			)}
			<Box
				sx={{
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
					position: 'absolute',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Typography
					variant='caption'
					component='div'
					color='text.secondary'
				>
					{props.value && `${Math.round(props.value)}%`}
				</Typography>
			</Box>
		</Box>
	);
};

export default CircularProgressWithLabel;
